<div class='main-content'>
  <div class='container-fluid'>
    <div class='card'>

      <div class='card-header card-header-info card-header-icon'>
        <div class='card-icon'>
          <i class='material-icons'>inventory</i>
        </div>
        <h4 class='card-title'>{{lastpage === 'inventory' ? 'Inventory' : 'History' }}</h4>
      </div> <br>

      <div class='card-body'>
        <div class='toolbar'>
          <!--        Here you can write extra buttons/actions for the toolbar              -->
        </div>

        <loading *ngIf='loading'></loading>

        <div *ngIf='!loading'>

          <div class="row">
            <div class="col-6">
              <h2>Detail {{lastpage === 'inventory' ? 'Inventory' : 'History' }} (ID: {{id}})</h2>
            </div>
            <div class="col-3">
              <div class="form-group" *ngIf="inventory.serialnumber !== null && inventory.serialnumber !== '' && showAttributes">
                <label class="bmd-label-floating"><b>Sanitization Status</b></label>
                <!--<input type="text" name="hddErasureresults" class="form-control fctrl" [(ngModel)]="sanitizationStatus" [readonly] style="font-size: 20px; font-weight: 900;"
                    [ngClass]="{'color-green': sanitizationStatus === 'PASSED', 'color-orange': sanitizationStatus === 'PARTIAL',
                    'color-red': sanitizationStatus === 'FAILED'}">-->
                <br>
                <span class="text-success" style="font-weight: bold; font-size: 16px;">
                  {{passed}}x Passed
                </span>
                <br>
                <span class="text-danger" style="font-weight: bold; font-size: 16px;">
                  {{failed}}x Failed
                </span>
                <br>
                <span class="text-warning" style="font-weight: bold; font-size: 16px;">
                  {{partial}}x Partial
                </span>
                <br>
                <span class="text-danger" style="font-weight: bold; font-size: 16px;">
                  {{destroyed}}x Destroyed
                </span>
                <br>
                <span class="text-danger" style="font-weight: bold; font-size: 16px;">
                  {{removed}}x Removed
                </span>
                
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label class="bmd-label-floating"><b>Status</b></label>
                <input
                  [ngClass]="{'color-green': inventory.status === 'Available', 'color-orange': inventory.status !== 'Available'}"
                  type="txt"
                  name="item"
                  [value]="inventory.status"
                  class="form-control fctrl font-weight-bolder"
                  style="font-size: 20px; font-weight: 900;"
                  readonly
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class='col-md-6'>

              <div class="row bloque mi">
                <div class="col-md-4">
                  <form>
                    <div class="form-group">
                      <label class="bmd-label-floating">
                        <b>
                          Item
                        </b>
                      </label>
                      <div class="input-group">
                        <input type="text" name="item" [(ngModel)]="inventory.item" class="form-control fctrl input-sm" readonly>
                        <!--<button *ngIf="lastpage !== 'inventoryhistory' && inventory.status === 'Available' && inventory.receivestatus === 'In Transit'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                            (click)="openItemModal()" [disabled]="saving">
                          <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                        </button>-->
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating">
                      <b>
                        Mfgr.
                      </b>
                    </label>
                    <input type="text" name="mfgr" class="form-control fctrl" [(ngModel)]="inventory.mfgr" readonly>
                  </div>
                </div>
                <!-- <div class="col-md-4">
                  <div style="margin-top: 9px;">
                    <mat-checkbox color="primary" name="bulk" [(ngModel)]="inventory.bulk" disabled>Bulk</mat-checkbox>
                  </div>
                </div> -->
              </div>

              <div class="row bloque mi">
                <div class='col-md-12'>

                  <h3 class='card-title title'><b>Purchase Info:</b></h3>
                  <hr>

                  <div class='row'>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            PO-Line
                          </b>
                        </label>
                        <input type="text" name="po" class="form-control fctrl" [(ngModel)]="inventory.po_line" readonly>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Purchased By
                          </b>
                        </label>
                        <input type="text" name="companyVendor" class="form-control fctrl"
                          [value]="inventory.po.rep.name[0] + inventory.po.rep.surname[0]" readonly>
                      </div>
                    </div>
                  </div>

                  <div class='row'>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Vendor ID
                          </b>
                        </label>
                        <input type="text" name="po" class="form-control fctrl" [value]="inventory.po.client.companyLinked.companyId" readonly>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Company Name
                          </b>
                        </label>
                        <input
                          type="text"
                          name="dateReceived" class="form-control fctrl" [value]="inventory.po.client.companyLinked.name" readonly>
                      </div>
                    </div>
                  </div>

                  <div class='row'>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating" style="margin-left: 15px;">
                          <b>
                            Purchase Cost
                          </b>
                        </label>
                        <div class="input-group">
                          <span class="input-group-btn material-icons" style="font-size: 23px; margin-top: 5px;">
                            attach_money
                          </span>
                          <input id="btn-input" name="purchaseCost" [(ngModel)]="inventory.originalunitcost" type="text"
                            class="form-control fctrl input-sm" readonly>

                        </div>

                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Purchase Date
                          </b>
                        </label>
                        <input
                          type="date"
                          name="purchaseDate" class="form-control fctrl" [(ngModel)]="inventory.po.date" readonly>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Date Received
                          </b>
                        </label>
                        <input
                          type="text"
                          name="dateReceived" class="form-control fctrl" [(ngModel)]="inventory.dateReceived" readonly>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div *ngIf="inventory.so" class="row bloque mi">
                <div class='col-md-12'>

                  <h3 class='card-title title'><b>Sales Info:</b></h3>
                  <hr>

                  <div class='row'>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            SO - Line
                          </b>
                        </label>
                        <input type="text" name="so" class="form-control fctrl" [(ngModel)]="inventory.so_line" readonly>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Sold By
                          </b>
                        </label>
                        <input type="text" name="rep" class="form-control fctrl"
                        [value]="inventory.so.rep.name[0] + inventory.so.rep.surname[0]" readonly>
                      </div>
                    </div>
                  </div>

                  <div class='row'>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Client
                          </b>
                        </label>
                        <input type="text" name="client" class="form-control fctrl"
                          [value]="inventory.so.client.companyLinked.companyId" readonly>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Company Name
                          </b>
                        </label>
                        <input type="text" name="companyClient" class="form-control fctrl"
                          [value]="inventory.so.client.companyLinked.name" readonly>
                      </div>
                    </div>
                  </div>

                  <div class='row'>
                    <div class="col-md-4">

                      <div class="form-group">
                        <label class="bmd-label-floating" style="margin-left: 15px;">
                          <b>
                            Sale Price
                          </b>
                        </label>
                        <div class="input-group">
                          <span class="input-group-btn material-icons" style="font-size: 23px; margin-top: 5px;">
                            attach_money
                          </span>
                          <input type="text" name="salePrice" class="form-control fctrl" [(ngModel)]="inventory.unitprice"
                          readonly>

                        </div>

                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Sale Date
                          </b>
                        </label>
                        <input type="text"
                          name="saleDate" class="form-control fctrl" value="{{inventory.so.saledate | date: 'MM/dd/yyyy, h:mm a'}}" readonly>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Invoice Date
                          </b>
                        </label>
                        <input type="text" name="rep" class="form-control fctrl"
                        value="{{inventory.datebooked | date: 'MM/dd/yyyy, h:mm a'}}" readonly>
                      </div>
                    </div>
                  </div>

                  <!-- <div class='row'>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">Reserved By</label>
                        <input type="text" name="reservedby" class="form-control fctrl" [(ngModel)]="inventory.reservedby"
                          readonly>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <label class="bmd-label-floating">Date Reserved</label>
                        <input
                          type="{{(inventory.dateReserved === null || inventory.dateReserved === '') ? 'text' : 'date'}}"
                          name="dateReserved" class="form-control fctrl" [(ngModel)]="inventory.dateReserved" readonly>
                      </div>
                    </div>
                  </div> -->

                </div>
              </div>

            </div>
            <div class='col-md-6'>

              <div class="row bloque">
                <div class="col-md-12">

                  <h3 class='card-title title'><b>Inventory Info:</b></h3>
                  <hr>

                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Reserved By
                          </b>
                        </label>
                        <input type="text" name="rep" class="form-control fctrl"
                        [value]="inventory.reservedBy" readonly>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Date Reserved
                          </b>
                        </label>
                        <input type="text" name="rep" class="form-control fctrl"
                        [value]="inventory.datereserved" readonly>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Returned by
                          </b>
                        </label>
                        <input type="text" name="rep" class="form-control fctrl"
                        [value]="inventory.returnedBy" readonly>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Date returned
                          </b>
                        </label>
                        <input type="text" name="rep" class="form-control fctrl"
                        [value]="inventory.dateReturned" readonly>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class='col-md-4'>

                      <div class="form-group">
                        <label class="bmd-label-floating"><b>Condition</b></label>
                        <div class="input-group">
                          <input type="text" name="condition" value="{{getconditionname()}}" class="form-control fctrl input-sm" readonly>
                          <span *ngIf="!inventory.so" class="input-group-btn">
                            <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                              (click)="edit('condition', inventory.condition_id)" *ngIf="lastpage !== 'inventoryhistory'">
                              <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class='col-md-8'>
                      <div class="form-group">
                        <label class="bmd-label-floating"
                          ><b>Warehouse</b></label
                        >
                        <span class="bmd-form-group">
                          <div class="input-group">
                            <input
                              type="txt"
                              name="warehouse"
                              [(ngModel)]="inventory.warehouse_name"
                              class="form-control fctrl"
                              disabled
                            />
                            <div class="input-group-prepend" *ngIf="lastpage !== 'inventoryhistory'">
                              <span class="input-group-text">
                                <button
                                  class="btn btn-warning btn-sm"
                                  (click)="ChangeWarehouse()"
                                >
                                  <i
                                    class="fa fa-random"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </span>
                            </div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class='col-md-12'>

                      <form>
                        <div class="form-group">
                          <label class="bmd-label-floating">
                            <b>
                              Location
                            </b>
                          </label>
                          <div class="input-group">
                            <input [hidden]="editlocation" type="text" name="location" [(ngModel)]="inventory.location" class="form-control fctrl input-sm" readonly>
                            <input id="el" [hidden]="!editlocation" type="text" name="elocation" [(ngModel)]="editValue" class="form-control fctrl input-sm">
                            <span *ngIf="!showSalesInfo" class="input-group-btn">
                              <button *ngIf="!editlocation && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="edit('location', inventory.location)" [disabled]="saving">
                                <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editlocation" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="save()" [disabled]="saving">
                                <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                                <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editlocation && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="restart(true)">
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </form>


                    </div>
                  </div>

                  <div class="row">
                    <div class='col-md-4'>
                      <div class="form-group">
                        <label class="bmd-label-floating">
                          <b>
                            Qty.
                          </b>
                        </label>
                        <input type="text" name="quantity" class="form-control fctrl" [(ngModel)]="inventory.quantity" readonly>
                      </div>
                    </div>
                    <div class='col-md-8'>

                      <form>
                        <div class="form-group">
                          <label class="bmd-label-floating">
                            <b>
                              Serial Number
                            </b>
                          </label>
                          <div class="input-group">
                            <input [hidden]="editSN" type="text" name="serialNumber" [(ngModel)]="inventory.serialnumber" class="form-control fctrl input-sm" readonly>
                            <input id="esn" [hidden]="!editSN" type="text" name="esn" [(ngModel)]="editValue" class="form-control fctrl input-sm">
                            <span *ngIf="!showSalesInfo" class="input-group-btn">
                              <button *ngIf="!editSN && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="edit('serialnumber', inventory.serialnumber)" [disabled]="saving">
                                <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editSN" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="save()" [disabled]="saving">
                                <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                                <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editSN && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="restart(true)">
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div class='row'>
                    <!--<div class='col-md-6'>
                      <div class="form-group">
                        <label class="bmd-label-floating"><b>Country of Origin</b></label>
                        <select
                          name="cofo"
                          [(ngModel)]="inventory.originCountry"
                          class="form-control fctrl"
                          disabled
                        >
                          <option value="null" disabled>Select Country of Origin</option>
                          <option *ngFor="let countrie of countries" value="{{ countrie.alpha2_code }}">
                            {{ countrie.alpha2_code }} - {{ countrie.name }}
                          </option>
                        </select>
                      </div>
                    </div>-->
                    <div class="col-6">
                      <div class="form-group">
                        <label class="bmd-label-floating"><b>Customer Asset</b></label>
                        <input
                          type="txt"
                          name="asset"
                          [(ngModel)]="inventory.customerAsset"
                          class="form-control fctrl"
                          readonly
                        />
                      </div>
                    </div>
                    <div class='col-md-6'>
                      <div class="form-group">
                        <label class="bmd-label-floating"><b>Receive Status</b></label>
                        <input type="text" name="receiveStatus" class="form-control fctrl"
                          [(ngModel)]="inventory.receivestatus" readonly>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="bmd-label-floating"><b>Container Inventory</b> &nbsp;
                          <i *ngIf="loadingContainers" class="fa fa-spinner fa-pulse fa-fw"></i>
                        </label>
                        <div class="input-group">
                          <app-filter-object
                          *ngIf="!loadingContainers"
                            [options]="containers"
                            [value]="inventory.container_id"
                            (selectChange)="saveContainer($event)"
                            class="form-control"
                            [disabled] = "lastpage === 'inventoryhistory'"
                          ></app-filter-object>
                          <span class="input-group-btn" *ngIf="lastpage !== 'inventoryhistory'">
                              <a class="btn btn-link btn-success btn-just-icon accion" (click)="create(0)"><i class="material-icons" >add_circle</i></a>
                          </span>
                          <button *ngIf="inventory.container_id !== ''" class='btn btn-sm btn-link btn-danger btn-just-icon'
                                (click)="removeContainer()" style="margin-top: 1px;">
                                <i class="fa fa-ban" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class='row'>
                    <div class='col-md-12'>

                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Virtual Container Inventory</b> &nbsp;
                          <i *ngIf="loadingVirtualContainers" class="fa fa-spinner fa-pulse fa-fw"></i>
                        </label>
                          <div class="input-group">
                            <app-filter-object
                              *ngIf="!loadingVirtualContainers"
                              [options]="virtualContainers"
                              [value]="inventory.idVirtualContainer"
                              (selectChange)="saveVirtualContainer($event)"
                              class="form-control"
                              [disabled] = "lastpage === 'inventoryhistory'"
                            ></app-filter-object>
                            <span class="input-group-btn" *ngIf="lastpage !== 'inventoryhistory'">
                              <a class="btn btn-link btn-success btn-just-icon accion" (click)="create(1)"><i class="material-icons" >add_circle</i></a>
                            </span>
                          </div>
                        </div>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      <div class="form-group">
                        <label class="bmd-label-floating"><b>Category</b></label>
                        <input
                          type="txt"
                          name="type"
                          [(ngModel)]="inventory.type"
                          class="form-control fctrl"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <label class="bmd-label-floating"><b>Testing Status</b></label>
                        <input
                          type="txt"
                          name="testing"
                          [(ngModel)]="inventory.testingStatus"
                          class="form-control fctrl"
                          readonly
                        />
                      </div>
                    </div>
                    <div class="col-4">

                      <form>
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Weight</b></label>
                          <div class="input-group">
                            <input [hidden]="editeWeight" type="number" name="weight" [(ngModel)]="inventory.weight" class="form-control fctrl input-sm" readonly>
                            <input id="eweight" [hidden]="!editeWeight" type="number" name="eweight" [(ngModel)]="editValue" class="form-control fctrl input-sm">
                            <span class="input-group-btn">
                              <button *ngIf="!editeWeight && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="edit('weight',inventory.weight)" [disabled]="saving">
                                <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editeWeight" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="save()" [disabled]="saving">
                                <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                                <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editeWeight && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="restart(true)">
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </form>

                    </div>
                  </div>

                  <div class='row'>
                    <div class='col-md-12'>

                      <form>
                        <div class="form-group">
                          <label class="bmd-label-floating"><b>Description</b></label>
                          <div class="input-group">
                            <input [hidden]="editDesc" type="text" name="description" [(ngModel)]="inventory.description" class="form-control fctrl input-sm" readonly>
                            <input id="edesc" [hidden]="!editDesc" type="text" name="edesc" [(ngModel)]="editValue" class="form-control fctrl input-sm">
                            <span *ngIf="!showSalesInfo" class="input-group-btn">
                              <button *ngIf="!editDesc && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="edit('description',inventory.description)" [disabled]="saving">
                                <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editDesc" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="save()" [disabled]="saving">
                                <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                                <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editDesc && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="restart(true)">
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </form>

                    </div>
                    <div class='col-md-3'>
                      <!-- <form>
                        <div class="form-group">
                          <label class="bmd-label-floating">Weight</label>
                          <div class="input-group">
                            <input [hidden]="editeWeight" type="text" name="weight" [(ngModel)]="inventory.weight" class="form-control fctrl input-sm" readonly>
                            <input id="eweight" [hidden]="!editeWeight" type="number" name="eweight" [(ngModel)]="editValue" class="form-control fctrl input-sm">
                            <span class="input-group-btn">
                              <button *ngIf="!editeWeight" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="edit('weight',inventory.weight)" [disabled]="saving">
                                <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editeWeight" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="save()" [disabled]="saving">
                                <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                                <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                              </button>
                              <button *ngIf="editeWeight && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                                (click)="restart(true)">
                                <i class="fa fa-ban" aria-hidden="true"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </form> -->
                    </div>
                  </div>

                  <div class='row'>
                    <div class='col-md-12'>

                      <form>
                        <div class="form-group">
                          <label class="bmd-label-floating">
                            <b>
                              Extended Description
                            </b>
                          </label>
                          <span *ngIf="!showSalesInfo" class="input-group-btn">
                            <button *ngIf="!editeEdesc && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                              (click)="edit('extendeddescription',inventory.extendeddescription)" [disabled]="saving">
                              <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                            </button>
                            <button *ngIf="editeEdesc" class='btn btn-sm btn-link btn-primary btn-just-icon'
                              (click)="save()" [disabled]="saving">
                              <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                              <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                            </button>
                            <button *ngIf="editeEdesc && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                              (click)="restart(true)">
                              <i class="fa fa-ban" aria-hidden="true"></i>
                            </button>
                          </span>
                          <!-- <textarea *ngIf="!editeEdesc" name="extendedDescription" class="form-control fctrl" [(ngModel)]="inventory.extendeddescription"
                            rows="10" readonly></textarea> -->
                          <!-- <textarea id="eEDesc" *ngIf="editeEdesc" name="eEDesc" class="form-control fctrl" [(ngModel)]="editValue"
                            rows="10"></textarea> -->

                            <ckeditor *ngIf="!editeEdesc" name="extendedDescription" [(ngModel)]="inventory.extendeddescription" [editor]="Editor" [data]="inventory.extendeddescription" disabled></ckeditor>
                            <ckeditor *ngIf="editeEdesc" name="editeEdesc" [(ngModel)]="editValue" [editor]="Editor" [data]="editValue"></ckeditor>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <hr>

          <div class="row bloque mi">
            <div class='col-md-12'>

              <div class="row">

                <div class='col-md-6'>

                  <form>
                    <div class="form-group">
                      <label class="bmd-label-floating">
                        <b>
                          Internal Comments
                        </b>
                      </label>
                      <span class="input-group-btn">
                        <button *ngIf="!editIC && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="edit('internalComments',inventory.internalComments)" [disabled]="saving">
                          <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editIC" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="save()" [disabled]="saving">
                          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                          <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editIC && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="restart(true)">
                          <i class="fa fa-ban" aria-hidden="true"></i>
                        </button>
                      </span>
                      <!-- <textarea *ngIf="!editIC" name="internalComments" class="form-control fctrl" [(ngModel)]="inventory.internalComments"
                        rows="3" readonly></textarea>
                      <textarea id="edIC" *ngIf="editIC" name="edIC" class="form-control fctrl" [(ngModel)]="editValue"
                        rows="3"></textarea> -->

                        <ckeditor *ngIf="!editIC" name="internalComments" [(ngModel)]="inventory.internalComments" [editor]="Editor" [data]="inventory.internalComments" disabled></ckeditor>
                        <ckeditor *ngIf="editIC" name="editIC" [(ngModel)]="editValue" [editor]="Editor"></ckeditor>
                    </div>
                  </form>


                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label class="bmd-label-floating" style="margin-top: 10px;">
                      <b>
                        Inventory System Comments
                      </b>
                    </label>
                    <textarea name="inventorySystemComments" class="form-control fctrl"
                      [(ngModel)]="systemComments" rows="4" readonly (wheel)="stopPropagation($event)"></textarea>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class='col-md-4'>

                  <form>
                    <div class="form-group">
                      <label class="bmd-label-floating">
                        <b>
                          SO Item Internal Comments
                        </b>
                      </label>
                      <span class="input-group-btn">
                        <button *ngIf="!editsoIC && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="edit('sointernalcomments',inventory.soItiemInternalComments)" [disabled]="saving">
                          <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editsoIC" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="save()" [disabled]="saving">
                          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                          <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editsoIC && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="restart(true)">
                          <i class="fa fa-ban" aria-hidden="true"></i>
                        </button>
                      </span>
                      <!-- <textarea *ngIf="!editsoIC" name="soItiemInternalComments" class="form-control fctrl" [(ngModel)]="inventory.soItiemInternalComments"
                        rows="3" readonly></textarea>
                      <textarea id="esoIC" *ngIf="editsoIC" name="esoIC" class="form-control fctrl" [(ngModel)]="editValue"
                        rows="3"></textarea> -->

                        <ckeditor *ngIf="!editsoIC" name="soItiemInternalComments" [(ngModel)]="inventory.soItiemInternalComments" [editor]="Editor" [data]="inventory.soItiemInternalComments" disabled></ckeditor>
                        <ckeditor *ngIf="editsoIC" name="esoIC" [(ngModel)]="editValue" [editor]="Editor"></ckeditor>
                    </div>
                  </form>

                </div>
                <div class='col-md-4'>

                  <form>
                    <div class="form-group">
                      <label class="bmd-label-floating">
                        <b>
                          Comments To Customer
                        </b>
                      </label>
                      <span class="input-group-btn">
                        <button *ngIf="!editCtoC && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="edit('commentstocustomer',inventory.commentsToCustomeer)" [disabled]="saving">
                          <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editCtoC" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="save()" [disabled]="saving">
                          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                          <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editCtoC && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="restart(true)">
                          <i class="fa fa-ban" aria-hidden="true"></i>
                        </button>
                      </span>
                      <!-- <textarea *ngIf="!editCtoC" name="commentsToCustomeer" class="form-control fctrl" [(ngModel)]="inventory.commentsToCustomeer"
                        rows="3" readonly></textarea>
                      <textarea id="ectc" *ngIf="editCtoC" name="ectc" class="form-control fctrl" [(ngModel)]="editValue"
                        rows="3"></textarea> -->

                        <ckeditor *ngIf="!editCtoC" name="commentsToCustomeer" [(ngModel)]="inventory.commentsToCustomeer" [editor]="Editor" [data]="inventory.commentsToCustomeer" disabled></ckeditor>
                        <ckeditor *ngIf="editCtoC" name="editCtoC" [(ngModel)]="editValue" [editor]="Editor"></ckeditor>
                    </div>
                  </form>

                </div>
                <div class='col-md-4'>

                  <form>
                    <div class="form-group">
                      <label class="bmd-label-floating">
                        <b>
                          Comments To Vendor
                        </b>
                      </label>
                      <span class="input-group-btn">
                        <button *ngIf="!editCtoV && lastpage !== 'inventoryhistory'" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="edit('commentstovendor',inventory.commentsToVendor)" [disabled]="saving">
                          <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editCtoV" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="save()" [disabled]="saving">
                          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                          <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="editCtoV && !saving" class='btn btn-sm btn-link btn-primary btn-just-icon'
                          (click)="restart(true)">
                          <i class="fa fa-ban" aria-hidden="true"></i>
                        </button>
                      </span>
                      <!-- <textarea *ngIf="!editCtoV" name="commentsToVendor" class="form-control fctrl" [(ngModel)]="inventory.commentsToVendor"
                        rows="3" readonly></textarea>
                      <textarea id="ectv" *ngIf="editCtoV" name="ectv" class="form-control fctrl" [(ngModel)]="editValue"
                        rows="3"></textarea> -->

                        <ckeditor *ngIf="!editCtoV" name="commentsToVendor" [(ngModel)]="inventory.commentsToVendor" [editor]="Editor" [data]="inventory.commentsToVendor" disabled></ckeditor>
                        <ckeditor *ngIf="editCtoV" name="ectv" [(ngModel)]="editValue" [editor]="Editor"></ckeditor>
                    </div>
                  </form>
                  
                </div>
              </div>
            </div>
          </div>

      <button (click)="showLogHistory()" class="btn btn-success btn-sm" *ngIf="this.logs.length > 0">
        <i class="fa fa-plus" aria-hidden="true"></i> &nbsp; Show Log History
      </button>     

      <div *ngIf="logHistory">
        <h3> <b>Log History</b> </h3>
        <hr>
      </div>

      <div style="background-color: #F2F3F4;" *ngIf="logHistory">

        <table class="table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Created At</th>
              <th scope="col">Comment</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of logs">              
              <td>{{log.id}}</td>
              <td>{{log.createdAt | date: 'MM/dd/yyyy H:mm:ss'}}</td>
              <td>{{log.comment}}</td>
            </tr>
          </tbody>
        </table>

      </div>


      <h3> <b>History</b> </h3>
      <hr>

      <div style="background-color: #F2F3F4;">

        <table class="table">
          <thead>
            <tr>
              <th scope="col">No.</th>
              <th scope="col">Line</th>
              <th scope="col">Date</th>
              <th scope="col">Rep</th>
              <th scope="col" style="text-align: right;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="inventory.pp">

              <th scope="row">PP: {{inventory.pp.pp}}</th>
              <td>{{inventory.pp.ppline}}</td>
              <td>{{inventory.pp.createdAt | date: 'MM/dd/yyyy'}}</td>
              <td>
                <span *ngIf="inventory.pp.rep">
                  {{inventory.pp.rep.name}} {{inventory.pp.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotopp(inventory.pp.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>
            <tr *ngIf="inventory.po">

              <th scope="row">PO: {{inventory.po.po}}</th>
              <td>{{inventory.poline}}</td>
              <td>
                {{inventory.po.date | date: 'MM/dd/yyyy'}}
              </td>
              <td>
                <span *ngIf="inventory.po.rep">
                  {{inventory.po.rep.name}} {{inventory.po.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotopo(inventory.po.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>
            <tr *ngIf="inventory.sp">

              <th scope="row">SP: {{inventory.sp.sp}}</th>
              <td>{{inventory.sp.spline}}</td>
              <td>{{inventory.sp.createdAt | date: 'MM/dd/yyyy'}}</td>
              <td>
                <span *ngIf="inventory.sp.rep">
                  {{inventory.sp.rep.name}} {{inventory.sp.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotosp(inventory.sp.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>

            <tr *ngIf="inventory.so">

              <th scope="row">SO: {{inventory.so.so}}</th>
              <td>{{inventory.soLine}}</td>
              <td>{{inventory.so.saledate | date: 'MM/dd/yyyy'}}</td>
              <td>
                <span *ngIf="inventory.so.rep">
                  {{inventory.so.rep.name}} {{inventory.so.rep.surname}}
                </span>
              </td>
              <td style="text-align: right;">
                <button class="btn btn-link btn-info btn-just-icon like"
                        (click)="gotoso(inventory.so.id)">
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
              </td>

            </tr>
          </tbody>
        </table>

      </div>



        </div>

        <div class="row">
          <div class='col-md-12' style="text-align: right;">
            <button (click)="removeHardDrives()" class="btn btn-danger btn-sm" *ngIf="inventory.serialnumber !== null && inventory.serialnumber !== '' && lastpage !== 'inventoryhistory' && showAttributes">
              <i class="fa fa-times" aria-hidden="true"></i> &nbsp; Remove Hard Drives
            </button> 
            &nbsp;
            &nbsp;
            <button (click)="inventoryAttributes(inventory.serialnumber)" class="btn btn-success btn-sm" *ngIf="inventory.serialnumber !== null && inventory.serialnumber !== '' && showAttributes || bitrasershow || phonecheckshow">
              <i class="fa fa-check-circle-o" aria-hidden="true"></i> &nbsp; Inventory Attributes<!-- buton -->
            </button> 
            &nbsp;
            &nbsp;
            <button type="button" class="btn btn-success btn-sm" (click)="modalSN()" *ngIf='!loading && lastpage !== "inventoryhistory" && !showAttributes && !bitrasershow && !phonecheckshow'>
              Match Serial Number
            </button>
            &nbsp;
            &nbsp;
            <button type="button" [ngClass]="inventory.testingStatus === 'TESTED' ? 'btn btn-danger btn-sm' : 'btn btn-success btn-sm'" (click)="testItem()" *ngIf='!loading && lastpage !== "inventoryhistory"'>
              {{inventory.testingStatus === 'TESTED' ? 'Mark Untested' : 'Mark Tested'}}
            </button>
            &nbsp;
            &nbsp;
            <button (click)="back()" class="btn btn-default btn-sm">
              <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back to list
            </button>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<div
  class="modal fade"
  id="changeWarehouse"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <app-filter-object *ngIf="!buscandoWharehouse"
                    [options]="wharehouseList"
                    [value]="inventory.warehouse_id"
                    (selectChange)="changeWH($event)"
                    placeholder="Wharehouse">
                  </app-filter-object>
      </div>

      <div class="modal-footer">
        <button class="btn btn-default btn-md" (click)="closeChangeWarehouse()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>


<div class='modal fade' id='myModal' tabindex='-1' role='dialog'>
  <div class='modal-dialog'>
    <div class='modal-content'>

      <div class='modal-header'>
        <h2><b>{{title}}</b></h2>
      </div>

      <div class='modal-body'>
        <form #f='ngForm'>

          <div class="row" [ngSwitch]="campo">
            <div class="col-md-12" *ngSwitchCase="'condition'">

              <mat-form-field>
                <!-- <mat-label>select condition</mat-label> -->
                <mat-select name="changeCondition" [(ngModel)]="editValue" required>
                  <mat-option *ngFor="let item of conditions" [value]="item.id">{{item.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- <div class="col-md-12" *ngSwitchCase="'location'">
              <mat-form-field class="example-full-width">
                <input matInput name="changeLocation" [(ngModel)]="editValue">
              </mat-form-field>
            </div> -->
            <div class="col-md-12" *ngSwitchCase="''">
              Editando otra cosa
            </div>
            <div class="col-md-12" *ngSwitchDefault>
              Holis
            </div>
          </div>


        </form>
      </div>

      <div class='modal-footer'>

        <button type='button' class='btn btn-danger btn-md' data-dismiss='modal'>
          Close
        </button>

        &nbsp; &nbsp;

        <button type='button' class='btn btn-primary btn-md' (click)="save()" [disabled]="!f.valid || saving">
          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp; {{saving ? 'Saving' : 'Save'}}
        </button>

      </div>

    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="modalSerialMatch">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Match Serial Number</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <input type="text" name="matchSerialNumber" class="form-control fctrl" [(ngModel)]="matchSerialNumber">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="matchSN()" [disabled]="matchSerialNumber === ''">Save</button>
        &nbsp;&nbsp;
        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="lineItemModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card">
          <div class="card-header card-header-success card-header-icon">
            <div class="card-icon">
              <i class="material-icons">add_shopping_cart</i>
            </div>
          </div>

          <div class="card-body">
            <form #f2="ngForm">
              <div>
                <div
                  class="row"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div
                    *ngIf="inventory.nonInventory === 0"
                    class="py-4"
                    style="margin: 0 5px; padding: 30px; width: 22%"
                    (click)="selectType('Inventory')"
                    [ngClass]="{
                      selected: itemType === 'Inventory',
                      option: itemType !== 'Inventory'
                    }"
                  >
                    <strong style="font-size: 17px">
                      <span class="material-icons">list_alt</span> &nbsp;
                      Inventory</strong
                    >
                  </div>
                  <div
                    *ngIf="inventory.nonInventory === 1"
                    class="py-4"
                    style="margin: 0 5px; padding: 30px; width: 22%"
                    (click)="selectType('NoInventory')"
                    [ngClass]="{
                      selected: itemType == 'NoInventory',
                      option: itemType != 'NoInventory'
                    }"
                  >
                    <strong style="font-size: 17px">
                      <span class="material-icons"
                        >desktop_access_disabled</span
                      >
                      &nbsp; No Inventory</strong
                    >
                  </div>
                </div>

                <br /><br />

                <div class="row" *ngIf="itemType == 'Inventory' || itemType == 'NoInventory'">
                  <div class="col-md-12">
                    <app-filter-line-items
                      [type]="itemType"
                      [cerrar]="cerrar"
                      [weightRequired]="weightRequired"
                      [showNonInventory]="itemType === 'NoInventory' ? 1 : 0"
                      (select)="saveItemMfgr($event)"
                    ></app-filter-line-items>
                  </div>
                </div>

              </div>

            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button
              type="button"
              class="btn btn-danger btn-md"
              (click)="closeItemModal()"
            >
              Close
            </button>
          </div>
          <div class="col-md-6" style="text-align: right">
            <!--<button
              *ngIf="
                selectedLineItem !== null || lineItem.type == 'ScrapInventory'
              "
              type="button"
              class="btn btn-success btn-md"
              (click)="agregarLineItem()"
              [disabled]="
                saving ||
                (lineItem.type == 'Inventory' && lineItem.quantity < 1) ||
                agregandoLineItem ||
                lineItem.condition === null
              "
            >
              <i
                *ngIf="agregandoLineItem"
                class="fa fa-circle-o-notch fa-spin fa-fw"
              ></i>
              Add
            </button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>